import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useStore } from "../context/StoreContext";

export const FloatingWhatsApp = () => {
  const { wa, count } = useStore();
  if (!wa) return null;
  return (
    <motion.a
      data-testid="floating-whatsapp-button"
      href={wa()}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with Lucky's Kitchen on WhatsApp"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/35 transition-[transform,bottom] duration-300 hover:scale-110 ${
        count > 0 ? "bottom-24 md:bottom-5" : "bottom-5"
      }`}
    >
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40 [animation-duration:2.6s]" />
      <MessageCircle className="h-7 w-7" />
    </motion.a>
  );
};
